import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Send, CheckCircle, Shield } from "lucide-react";

export default function ScoutApply() {
  const [form, setForm] = useState({ name: "", organisation: "", role_title: "", email: "", country: "", description: "" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const update = (key, val) => setForm((p) => ({ ...p, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/scout/apply", form);
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="bg-[#0A0A0A] min-h-screen flex items-center justify-center px-4" data-testid="scout-apply-success">
        <div className="text-center max-w-md">
          <CheckCircle size={40} className="text-[#D4AF37] mx-auto mb-5" />
          <h1 className="text-2xl font-black tracking-tighter uppercase text-[#F5F5F5] mb-3">APPLICATION SUBMITTED</h1>
          <p className="text-sm text-[#A3A3A3] mb-6 leading-relaxed">
            Your application is under review. You will be contacted once a decision has been made. This process is handled internally.
          </p>
          <Link to="/" className="btn-outline text-sm px-6 py-2.5">RETURN TO HOME</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#0A0A0A] min-h-screen py-20 px-4" data-testid="scout-apply-page">
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-10">
          <Shield size={28} className="text-[#D4AF37] mx-auto mb-4" />
          <h1 className="text-2xl sm:text-3xl font-black tracking-tighter uppercase text-[#F5F5F5] mb-2">SCOUT ACCESS APPLICATION</h1>
          <p className="text-sm text-[#A3A3A3] leading-relaxed">
            The Elite Scouting Network directory is a controlled environment. Scout access is reviewed and approved internally.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="card-dark p-6 sm:p-8 space-y-4" data-testid="scout-form">
          <div>
            <label className="overline block mb-1.5">FULL NAME *</label>
            <input type="text" value={form.name} onChange={(e) => update("name", e.target.value)} className="input-dark" required data-testid="scout-name" />
          </div>
          <div>
            <label className="overline block mb-1.5">ORGANISATION / CLUB *</label>
            <input type="text" value={form.organisation} onChange={(e) => update("organisation", e.target.value)} className="input-dark" required data-testid="scout-org" />
          </div>
          <div>
            <label className="overline block mb-1.5">YOUR ROLE *</label>
            <input type="text" value={form.role_title} onChange={(e) => update("role_title", e.target.value)} className="input-dark" placeholder="e.g. Scout, Analyst, Head of Recruitment" required data-testid="scout-role" />
          </div>
          <div>
            <label className="overline block mb-1.5">EMAIL *</label>
            <input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} className="input-dark" required data-testid="scout-email" />
          </div>
          <div>
            <label className="overline block mb-1.5">COUNTRY *</label>
            <input type="text" value={form.country} onChange={(e) => update("country", e.target.value)} className="input-dark" required data-testid="scout-country" />
          </div>
          <div>
            <label className="overline block mb-1.5">WHY ARE YOU APPLYING? *</label>
            <textarea value={form.description} onChange={(e) => update("description", e.target.value)} className="input-dark min-h-[80px] resize-y" placeholder="Brief description of your scouting activity and interest in the network" required data-testid="scout-desc" />
          </div>
          <button type="submit" disabled={loading} className="btn-gold w-full flex items-center justify-center gap-2 disabled:opacity-50" data-testid="scout-submit">
            {loading ? <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" /> : <Send size={14} />}
            {loading ? "SUBMITTING..." : "SUBMIT APPLICATION"}
          </button>
          <p className="text-[10px] text-[#555] text-center">Applications are reviewed internally. Access is not guaranteed.</p>
        </form>
      </div>
    </div>
  );
}
